import { useTheme } from '../../contexts/ThemeContext';
import classNames from 'classnames';

export default function GlassCard({
  children,
  className = '',
  variant = 'default',
  padding = 'md',
  hover = false
}) {
  const { darkMode } = useTheme();

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10'
  };

  return (
    <div
      className={classNames(
        darkMode ? 'glass-card-dark' : 'glass-card',
        paddingClasses[padding],
        hover && 'transition-all duration-300 hover:scale-[1.02] hover:shadow-lg',
        className
      )}
    >
      {children}
    </div>
  );
}
